$(document).ready(function () {
      async function removeItem(data) {
        const result = await fetch("/cart/change.json", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                ...data,
                quantity: 0
            })
        });
        return result.json();
    }
    setTimeout(() => {
        $('#shopify-section-product-template #customily-options').prepend('<h3 class="title-customily">Customize</h3>');
        console.log("ok");
    }, 1500);
  $(".cart__item-preview .lightbox").click(function (e) { 
    let linkImg = $(this).attr('data-img');
    $(".modal-previev-cart").addClass("is-open");
    $(".modal-previev-cart .preview-img-modal-confirm img").attr('src', linkImg);
  });
  $('.modal-previev-cart #checkout').click(function (e) { 
    $(this).addClass("active");
    $('#cart_form #checkout').trigger('click'); 
  });
  $('.modal-previev-cart .icon-closed').click(function (e) { 
    $(".modal-previev-cart").removeClass("is-open");
  });
  $('.modal-previevpersonalization .handle-cancel-confirm-modal').click(function (e) { 
    $(".modal-previevpersonalization").removeClass("is-open");
  });
  $('.modal-previev-cart .overlay-modal-confirm').click(function (e) { 
    $(".modal-previev-cart").removeClass("is-open");
  });
  $('.modal-previevpersonalization .overlay-modal-confirm').click(function (e) { 
    $(".modal-previevpersonalization").removeClass("is-open");
  });
   $('.modal-previevpersonalization .handle-oke-confirm-modal').click(function (e) {
     let lineid = $(this).attr("data-line-id"); 
     removeItem({ line: lineid });
     let link = $(this).attr('redirect');
     window.location.href=link;
  });
  
  $('#shopify-section-cart-template .cart__wrapper .edit-personalization').click(function (e) { 
    let linkImg = $(this).attr('data-img');
    let redirectPro = $(this).attr('redirect');
    $(".modal-previevpersonalization").addClass("is-open");
    $(".modal-previevpersonalization .preview-img-modal-confirm img").attr('src', linkImg);
    let idRemo = $(this).next(".cart__remove-btn").attr("data-line-id");
    $('.modal-previevpersonalization .handle-oke-confirm-modal').attr("data-line-id",idRemo);
    $('.modal-previevpersonalization .handle-oke-confirm-modal').attr("redirect",redirectPro);
    
  });
  $('.main_nav .vertical-menu>.sublink').click(function (e) {
    if($(this).hasClass('active')){
      $(this).removeClass("active");
    }
    else{
      $(this).siblings().removeClass('active');
      $(this).addClass('active');
    }
  });
  $(document).mouseup(function (e) {
     var container = $(".main_nav .vertical-menu>.sublink");
     if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass("active");
     }
  });
  
  $('.tracking-faq .faq-item-content').click(function () {
    $(this).toggleClass("active").children(".faq-item-panel").slideToggle();
    $(".faq-item-panel").not($(this).children(".faq-item-panel")).slideUp(300);
    $(this).siblings().removeClass("active");
  });
  $('.to-top').click(function() {
        $("html,body").animate({
            scrollTop: 0
                }, 600);
            });
        $(window).scroll(function() {
        if ($(this).scrollTop()) {
            $('.to-top:hidden').stop(true, true).fadeIn();
        } else {
            $('.to-top').stop(true, true).fadeOut();
        }
    });
  $(".nav-reviews").click(function() {
    $('html,body').animate({
        scrollTop: $("#shopify-section-product-template .jdgm-rev-widg__body").offset().top},
        'slow');
  });
  $(".minus").on("click", function (e) {
        e.preventDefault();
        var $this = $(this);
        var $input = $this.closest("div").find("input");
        var value = parseInt($input.val());

        if (value > 1) {
            value = value - 1;
        } else {
            value = 1;
        }

        $input.val(value);
        $input.change();
    });

    $(".plus").on("click", function (e) {
        e.preventDefault();
        var $this = $(this);
        var $input = $this.closest("div").find("input");
        var value = parseInt($input.val());

        if (value < 100) {
            value = value + 1;
        } else {
            value = 100;
        }

        $input.val(value);
        $input.change();
    });
   $("#shopify-section-product-template").addClass("active-customzize");
  $("#js-btn-customzize").hide();
  $.fancybox.close();
});

const eyeCloseIcon = ` <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M15.9202 12.7988C15.9725 12.5407 16 12.2736 16 12C16 9.79086 14.2091 8 12 8C11.7264 8 11.4593 8.02746 11.2012 8.07977L12.1239 9.00251C13.6822 9.06583 14.9342 10.3178 14.9975 11.8761L15.9202 12.7988ZM9.39311 10.5143C9.14295 10.9523 9 11.4595 9 12C9 13.6569 10.3431 15 12 15C12.5405 15 13.0477 14.857 13.4857 14.6069L14.212 15.3332C13.5784 15.7545 12.8179 16 12 16C9.79086 16 8 14.2091 8 12C8 11.1821 8.24547 10.4216 8.66676 9.78799L9.39311 10.5143Z" fill="#333333"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M16.1537 17.2751L15.4193 16.5406C14.3553 17.1196 13.1987 17.5 12 17.5C10.3282 17.5 8.73816 16.7599 7.36714 15.7735C6.00006 14.79 4.89306 13.5918 4.19792 12.7478C3.77356 12.2326 3.72974 12.1435 3.72974 12C3.72974 11.8565 3.77356 11.7674 4.19792 11.2522C4.86721 10.4396 5.9183 9.29863 7.21572 8.33704L6.50139 7.62271C5.16991 8.63072 4.10383 9.79349 3.42604 10.6164L3.36723 10.6876C3.03671 11.087 2.72974 11.4579 2.72974 12C2.72974 12.5421 3.0367 12.913 3.36723 13.3124L3.42604 13.3836C4.15099 14.2638 5.32014 15.5327 6.78312 16.5853C8.24216 17.635 10.0361 18.5 12 18.5C13.5101 18.5 14.9196 17.9886 16.1537 17.2751ZM9.18993 6.06861C10.0698 5.71828 11.0135 5.5 12 5.5C13.9639 5.5 15.7579 6.365 17.2169 7.41472C18.6799 8.46727 19.849 9.73623 20.574 10.6164L20.6328 10.6876C20.9633 11.087 21.2703 11.4579 21.2703 12C21.2703 12.5421 20.9633 12.913 20.6328 13.3124L20.574 13.3836C20.0935 13.9669 19.418 14.721 18.5911 15.4697L17.883 14.7617C18.6787 14.0456 19.3338 13.3164 19.8021 12.7478C20.2265 12.2326 20.2703 12.1435 20.2703 12C20.2703 11.8565 20.2265 11.7674 19.8021 11.2522C19.107 10.4082 18 9.21001 16.6329 8.22646C15.2619 7.24007 13.6718 6.5 12 6.5C11.3056 6.5 10.6253 6.62768 9.96897 6.84765L9.18993 6.06861Z" fill="#333333"/> <path d="M5 2L21 18" stroke="#333333"/></svg>
  `;
  const eyeIcon = ` <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="12" cy="12" r="3.5" stroke="#333333"/> <path d="M20.188 10.9343C20.5762 11.4056 20.7703 11.6412 20.7703 12C20.7703 12.3588 20.5762 12.5944 20.188 13.0657C18.7679 14.7899 15.6357 18 12 18C8.36427 18 5.23206 14.7899 3.81197 13.0657C3.42381 12.5944 3.22973 12.3588 3.22973 12C3.22973 11.6412 3.42381 11.4056 3.81197 10.9343C5.23206 9.21014 8.36427 6 12 6C15.6357 6 18.7679 9.21014 20.188 10.9343Z" stroke="#333333"/></svg>
  `;
  function showRecoverPasswordForm() {
    document.getElementById('recover_password_popup').style.display = 'block';
    document.getElementById('form_login_popup').style.display='none';
    return false;
  }

  function hideRecoverPasswordForm() {
    document.getElementById('recover_password_popup').style.display = 'none';
    document.getElementById('form_login_popup').style.display = 'block';
    return false;
  }
  
  function showRegisterForm() {
    document.getElementById('form_register_popup').style.display = 'block';
    document.getElementById('form_login_popup').style.display = 'none';
    document.getElementById('recover_password_popup').style.display = 'none'
    return false;
  }

  function hideRegisterForm() {
    document.getElementById('form_register_popup').style.display = 'none';
    document.getElementById('form_login_popup').style.display = 'block';
    return false;
  }
  
  function togglePassword(id, idIcon) {
    const x = document.getElementById(id);
    const icon = document.getElementById(idIcon);
    if (x.type === "password") {
      x.type = "text";
      icon.innerHTML = eyeIcon;
    } else {
      x.type = "password";
      icon.innerHTML = eyeCloseIcon;
    }
  }

  if (window.location.hash == '#recover') { showRecoverPasswordForm() }

  // reset_success is only true when the reset form is
  
$(document).ready(function () {
  /*
  * Log the customer in with their email and password.
  */
  $('#form_login').submit(function(e){ 
    try {
      e.preventDefault();
      const $inputs = $('#form_login input');
      const values = {};
      $inputs.each(function() {
        values[this.name] = $(this).val();
      });
      const data = {
        'customer[email]': values.email,
        'customer[password]': values.password,
        form_type: 'customer_login',
        utf8: '✓'
      };

      const loginBtn = $('#login_btn');
      const promise = $.ajax({
        url: '/account/login',
        method: 'post',
        data: data,
        dataType: 'html',
        async: true,
        beforeSend: function () {
          loginBtn.prop('disabled', true);
          loginBtn.val('Loading...');
        },
        complete: function (cc) {
          loginBtn.prop('disabled', false);
          loginBtn.val("Login");
        },
      });

      promise.done(function (response) {
        const loginError = $("#login_error");
        const logErrors = jQuery(response).find('.errors').text();
        if (logErrors != '' && logErrors != 'undefined'){
          loginError.html(logErrors);
        } else{
          showSnackBar('You are successfully logged in');
          loginError.empty();
          $.fancybox.close();
          window.location.reload();
        }
      });
    } catch(err) {
    	console.log(err);
        const loginBtn = $('#login_btn');
        loginBtn.prop('disabled', false);
        loginBtn.val("Login");
    }
  });

  /*
  * Register customer
  */
  $('#create_customer').submit(function(e){ 
    try {
      e.preventDefault();
      const $inputs = $('#create_customer input');
      const values = {};
      $inputs.each(function() {
        values[this.name] = $(this).val();
      });
      const data = {
        'customer[email]': values.email,
        'customer[password]': values.password,
        'customer[first_name]': values.firstName,
        'customer[last_name]': values.lastName,
        form_type: 'create_customer',
        utf8: '✓'
      };

      const registerBtn = $('#btn_register');
      const promise = $.ajax({
        url: '/account',
        method: 'post',
        data: data,
        dataType: 'html',
        async: true,
        beforeSend: function () {
          registerBtn.prop('disabled', true);
          registerBtn.val('Loading...');
        },
        complete: function () {
          registerBtn.prop('disabled', false);
          registerBtn.val("Sign Up");
        },
      });
          
      promise.done(function (response) {
        const registerError = $("#register_error");
        const logErrors = jQuery(response).find('.errors').text();
        if (logErrors != '' && logErrors != 'undefined'){
          registerError.html(logErrors);
        } else{
          showSnackBar('You have successfully registered');
          registerError.empty();
          $.fancybox.close();
          window.location.reload();
        }
      });
    } catch(err) {
    	console.log(err);
        registerBtn.prop('disabled', false);
        registerBtn.val("Sign Up");
    }
  });
      
  /*
  * Get the `checkout_url` from the URL query parameter, if it exists.
  * (It only ever exists on the /account/login page)
  */
  function getCheckoutUrl() {  
    function getParameterByName(name) {
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
          results = regex.exec(location.search);
      return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }
    return getParameterByName('checkout_url');
  }

  // Show snackbar
  function showSnackBar(message) {
    var x = document.getElementById("snackbar");
    x.className = "show";
    x.innerHTML = message;
    setTimeout(function(){ x.className = x.className.replace("show", ""); }, 3000);
  }
  $.fancybox.close();
  });
setTimeout(() => {
    let html = '<h5 class="preview-title" style="background: #fff;margin: 0;font-size: 26px;font-weight: 500;">Preview</h5>';
    let btn = '<div id="preview-cart-btn" style="display: block;background: #fff;padding: 15px;font-weight: bold;"><span class="action_button add_to_cart" style="width: fit-content;font-weight: bold;height: 50px;padding: 0 35px;">ADD TO CART</span></button>';
    if ($(window).width() < 850) {
    document.querySelector('.customily-modal-preview-only .main').insertAdjacentHTML('afterbegin', html);
    document.querySelector('.customily-modal-preview-only .main').insertAdjacentHTML('beforeend', btn);
      if ($('.purchase-details button').hasClass('customily-preview-button')) {
           const html = '<button id="fixed-preview">Preview</button>';
           document.querySelector('.purchase-details').insertAdjacentHTML('beforeend', html);
      }
      $('#fixed-preview').click(function (e) { 
       $('.product .customily-preview-button').trigger('click');
     });
    }
   if ($(window).width() > 1023) {
    document.querySelector('.customily-modal-preview-only .main').insertAdjacentHTML('afterbegin', html);
    document.querySelector('.customily-modal-preview-only .main').insertAdjacentHTML('beforeend', btn);
      if ($('.purchase-details button').hasClass('customily-preview-button')) {
           const html = '<button id="fixed-preview">Preview</button>';
           document.querySelector('.purchase-details').insertAdjacentHTML('beforeend', html);
      }
   }
  
   $('#fixed-preview').click(function (e) { 
     $('.product .customily-preview-button').trigger('click');
   });
  $('#preview-cart-btn span').click(function (e) { 
     $('.product #customily-cart-btn.add_to_cart').trigger('click');
   });
  $('.jdgm-rev-widg__sort-wrapper').insertAfter('.jdgm-subtab');
}, 3000);
